import { createRouter, createWebHistory } from 'vue-router'
import CryptoJS from 'crypto-js'
import * as seo from '@/utils/seo'
import * as organizationProfile from '@/utils/organization_profile'
import Sign_in_finale from '@/views/Sign_In_Finale/Sign_in_finale.vue'
import Ads_center from '@/views/Ads_Center/ads_center.vue'
import Sign_up_Finale from '@/views/Sign_up_Finale/Sign_up_Finale.vue'
import Dashboard from '@/views/Dashboard/DashboardView.vue'
import CreatePortal from '@/views/CreatePortal/CreatePortalView.vue'
import CreateUser from '@/views/CreateUser/CreateUserView.vue'
import ViewPortal from '@/views/ViewPortal/ViewPortalView.vue'
import CreateSegment from '@/views/CreateSegment/CreateSegmentView.vue'
import Home from '@/views/home/HomeView.vue'
import OneTimePin from '@/views/otp/OTPView.vue'
import PasswordChange from '@/views/first_time_password/PasswordView.vue'
import ViewTopic from '@/views/ViewTopic/ViewTopicView.vue'
import Home_Filter from '@/views/home_filter/HomeFilterView.vue'
import HomeNavBar from '@/components/HomeNavBar/HomeNavBar.vue'
import CustomerProfile from '@/views/CustomerProfile/CustomerProfile.vue'
import BusinessProfileView from '@/views/BusinessProfileView/BusinessProfileView.vue'
import CustomerProfileView from '@/views/CustomerProfileView/CustomerProfileView.vue'
import CreateGroup from '@/views/CreateGroup/CreateGroupView.vue'
import CreateAsset from '@/views/CreateAsset/CommunityAsset.vue'
import GroupView from '@/views/group_view/GroupView.vue'
import IncidentReporting from '@/views/IncidentReporting/IncidentReportingView.vue'
import ViewIncidentReports from '@/components/GetIncidentReports/ViewIncidentReports.vue'
import MyLearningErrorPage from '@/components/MyLearningErrorPage/MyLearningErrorPage.vue'
import UserComponent from '@/components/UserComponent/UserComponent.vue'
import ViewEvents from '@/views/View_Events/ViewEvents.vue'
import ViewEvent from '@/views/View_event/view_event.vue'
import OrganizationProfileSetup from '@/views/OrganizationProfileSetup/OrganizationProfileSetup.vue'
import OrganizationMembers from '@/views/OrganizationMembers/OrganizationMembers.vue'
import OrganizationInviteResponse from '@/views/OrganizationInviteResponse/OrganizationInviteResponse.vue'
import OrganizationInviteSetup from '@/views/OrganizationInviteSetup/OrganizationInviteSetup.vue'
import RSVP from '@/views/RSVP_management/GET_RSVP.vue'
import ManageRoles from '@/views/ManageRoles/CreatePortalRoleView.vue'
import ViewIncidents from '@/views/ViewIncidentReport/ViewIncidentReport'
import CreateMembership from '@/views/CreateMembership/CreateMembership.vue'
import CreateForm from '@/views/CreateForm/CreateForm.vue'
import CreateSectionQuestion from '@/views/CreateSectionQuestion/CreateSectionQuestion.vue'
import ManageSections from '@/views/ManageSections/ManageSections.vue'
import CommunityAsset from '@/components/GetCommunityAssets/CommunityAsset.vue'
import CreateService from '@/components/CreateServices/CreateServiceView.vue'
import ViewMembership from '@/views/ViewMembership/ViewMembership.vue'
import AssignQuestion from '@/components/AssignQuestion/AssignQuestion.vue'
import ManageQuestion from '@/components/ManageQuestion/ManageQuestion.vue'
import FolderView from '@/components/FolderTree/FolderTree.vue';
import ViewBusinessProfiles from '@/views/ViewProfiles/ViewProfiles.vue'
import ViewProfileProfiles from '@/views/ViewPersonalProfile/ViewPersonalProfile.vue'
import PublishPortal from '@/views/PublishingPortal/PublishingPortal.vue'
import AllEvents from '@/views/GetEvents/GetEvents.vue'
import UpcomingBirthdays from '@/components/Upcoming_Birthdays/UpcomingBirthdays.vue'
import PersonalProfileList from '@/components/PersonalProfileList/PersonalProfileList.vue'
import Adverts from '@/components/Adverts/Adverts.vue'
import ViewPublishReport from '@/views/ViewPublishReport/ViewPublishReport.vue'
import ViewMembershipUsers from '@/views/ViewMembershipUsers/ViewMembershipUsers.vue'
import Board from '@/views/Board/BoardView.vue'
import BusinessDashboard from '@/views/BusinessDashboard/BusinessDashboard.vue'
import ViewAllBirthdays from '@/views/ViewAllBirthdays/ViewAllBirthdays.vue'
import ViewAllGroups from '@/views/ViewAllGroups/ViewAllGroups.vue'
import CheckoutPage from '@/views/CheckoutPage/CheckoutPage.vue'
import ViewUserTickets from '@/views/EventTicketManagement/EventTicket.vue'
import FAQ from '@/components/FAQ/FAQ.vue'
import library from '@/views/Library/Library.vue'
import ViewRecentUploads from '@/views/ViewRecentUploads/ViewRecentUploads.vue'
import AicView from '@/views/aic_view/AicView.vue'
import NSPLanding from '@/LandingPage/NSPLanding/NSPLanding.vue'
import KnowledgeHub from '@/LandingPage/DWYPDLanding/DWYPDLanding.vue'
import Courses from '@/components/CoursePage/CoursePage.vue'
import CreateAssets from '@/components/ManageAssets/CreateAssets.vue'
import CreateProfileTabs from '@/views/CreateProfileTabs/CreateProfileTabs.vue'
import NationalYouthPolicyDashboard from '@/components/KnowledgeHub/NationalYouthPolicy/NationalYouthPolicyView.vue'
import DSD from '@/components/VSIDashboards/DSDDashboard/DSDDashboardView.vue'
import PWD from '@/components/KnowledgeHub/PWD_dashboard/PWDdashboardView.vue'
import GBV from '@/components/KnowledgeHub/GBV_Dashboard/gbvDashboarView.vue'
import KnowledgeInsights from '@/components/KnowledgeHub/KnowledgeHubDashboard/InsightsView.vue'
import CreateDiscussion from '@/views/CreateDiscussion/CreateDiscussion.vue'
import CreateSurvey from '@/views/CreateSurvey/CreateSurvey.vue'
import CreatePolls from '@/views/CreatePolls/CreatePolls.vue'
import Marketplace from '@/views/Marketplace/Marketplace.vue'
import UnifiedSearchResults from '@/views/UnifiedSearchResults/UnifiedSearchResults.vue'
import CartCheckoutView from '@/views/cart_checkout/CartCheckoutView.vue'
import OrderView from '@/views/Orders/OrderView.vue'
import CreditManagementView from '@/views/CreditManagement/CreditManagementView.vue'
import MyOrdersView from '@/views/MyOrders/MyOrdersView.vue'
import MyShopView from '@/views/MyShop/MyShop.vue'
import PageNotFound from '@/views/PageNotFound.vue'
import ProductView from '@/views/ProductView/ProductView.vue'
import AssessmentTools from '@/views/AssessmentTools/AssessmentToolsView.vue'
import PromoCodesView from '@/views/PromoCodes/PromoCodesView.vue'
import ManageCatalogue from '@/views/ManageCatalogue/CatalogueView.vue'
import ManageEvent from '@/views/manage_event/manage_event.vue'
import DonationCampaignsView from '@/views/DonationCampaigns/DonationCampaignsView.vue'
import MyDonationCampaignsView from '@/views/MyDonationCampaigns/MyDonationCampaignsView.vue'
import DonationCampaignDashboardView from '@/views/DonationCampaignDashboard/DonationCampaignDashboardView.vue'
import manage_membership from '@/views/manage_membership/manage_mebership.vue'

const encryption_key = process.env.VUE_APP_ENCRYPTION_KEY;
export function set_token(token) {
  if (!token) {
    localStorage.removeItem("encrypted_token"); // Remove token if empty
    return;
  }

  const encrypted_token = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(token),
    encryption_key
  ).toString();

  localStorage.setItem("encrypted_token", encrypted_token);
}

export function get_token() {
  let encrypted_token = localStorage.getItem("encrypted_token");


  // ✅ Check if the token is missing or empty
  if (!encrypted_token) return null;

  try {
    let decrypted_bytes = CryptoJS.AES.decrypt(encrypted_token, encryption_key);
    let token = decrypted_bytes.toString(CryptoJS.enc.Utf8);


    if (!token) {
      console.warn("Decryption failed: empty token");
      return null;
    }

    return token;
  } catch (error) {
    console.error("Token decryption error:", error);
    return null; // Gracefully handle decryption failure
  }
}
const routes = [

  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/marketplace',
    name: 'Marketplace',
    component: Marketplace
  },

  {
    path: '/aic_view/:token?/:user_id?/:role?/',
    name: 'AICView',
    component: AicView,
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      const token = to.params.token;
      const userId = to.params.user_id;
      const userRole = to.params.user_role || to.params.role;

      if (token && userId) {
        set_token(token);
        localStorage.setItem('aic_one_login', 'true');
        localStorage.setItem('user_id', userId);
        localStorage.setItem('user_role', userRole);
        next();
      } else {
        next('/');
      }
    }
  },

  {
    path: '/sign_up_Finale',
    name: 'sign_up_Finale',
    component: Sign_up_Finale
  },
  {
    path: '/homenav',
    name: 'homenav',
    component: HomeNavBar
  },
  // {
  //   path: '/',
  //   name: 'sign_in_finale',
  //   component: Sign_in_finale
  // },
  {
    path: '/sign_in_finale',
    alias: '/sign_in_Finale',
    name: 'sign_in_finale',
    component: Sign_in_finale
  },
  {
    path: '/ads_center',
    name: 'ads_center',
    component: Ads_center
  },
  {
    path: '/first_password_change',
    name: 'first_password_change',
    component: PasswordChange,
    meta: { requiresAuth: true }
  },

  {
    path: '/otp',
    name: 'otp',
    component: OneTimePin,
    meta: { requiresAuth: true }
  },

  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_portal',
    name: 'create_portal',
    component: CreatePortal,
    meta: { requiresAuth: true }
  },

  {
    path: '/manage_roles',
    name: 'manage_roles',
    component: ManageRoles,
    meta: { requiresAuth: true }
  },

  {
    path: '/get_rsvps/:event_id',
    name: 'get_rsvps',
    component: RSVP,
    meta: { requiresAuth: true }
  },

  {
    path: '/manage_rsvps/',
    name: 'manage_rsvps',
    component: RSVP,
    meta: { requiresAuth: true }
  },

  {
    path: '/view_portal/:portal_id/:portal_name/:is_public/:is_visible?',
    name: 'view_portal',
    component: ViewPortal,
    meta: { requiresAuth: true },

  },

  {
    path: '/create_segment/:portal_id/:portal_type?/',
    name: 'create_segment',
    component: CreateSegment,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_user',
    name: 'create_user',
    component: CreateUser,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_group',
    name: 'create_group',
    component: CreateGroup,
    meta: { requiresAuth: true }
  },
  {
    path: '/create_asset',
    name: 'create_asset',
    component: CreateAsset,
    meta: { requiresAuth: true }
  },
  {
    path: '/view_group/:portal_id?/:group_id?/:group_name?/:is_public?/',
    name: 'view_group',
    component: GroupView,
    meta: { requiresAuth: true },
    props: true
  },

  {
    path: '/create_report',
    name: 'view_topic',
    component: ViewTopic,
    props: true
  },
  {
    path: '/create_report/:topic_id/',
    name: 'view_report_topic',
    component: ViewTopic,
    props: true
  },

  {
    path: '/create_report/tag/:tag_id/',
    name: 'view_report_tag',
    component: ViewTopic,
    props: true
  },

  {
    path: '/home_filter/',
    name: 'home_filter',
    component: Home_Filter,
    meta: { requiresAuth: true, requires_organization_admin: true }
  },

  {
    path: '/profile/business/:profile_slug',
    name: 'business_profile_direct',
    component: BusinessProfileView
  },
  {
    path: '/profile/personal/:profile_slug',
    name: 'personal_profile_direct',
    component: CustomerProfileView
  },

  {
    path: '/organization_profile_setup',
    name: 'organization_profile_setup',
    component: OrganizationProfileSetup,
    meta: { requiresAuth: true, requires_organization_admin: true }
  },
  {
    path: '/organization_members',
    name: 'organization_members',
    component: OrganizationMembers,
    meta: { requiresAuth: true, requires_organization_admin: true }
  },
  {
    path: '/organization_invite/:token?',
    name: 'organization_invite',
    component: OrganizationInviteResponse,
    meta: { requiresAuth: false }
  },
  {
    path: '/organization_invite_setup/:token?',
    name: 'organization_invite_setup',
    component: OrganizationInviteSetup,
    meta: { requiresAuth: false }
  },

  {
    path: '/incident_reporting',
    name: 'incident_reporting',
    component: IncidentReporting
  },

  {
    path: '/view_incident_reports',
    name: 'view_incident_reports',
    component: ViewIncidentReports
  },

  {
    path: '/my_learning',
    name: 'my_learning',
    component: MyLearningErrorPage
  },

  {
    path: '/user_component',
    name: 'user_component',
    component: UserComponent
  },

  {
    path: '/view_events',
    name: 'view_events',
    component: ViewEvents,
    meta: { requiresAuth: false }
  },

  {
    path: '/view_event/:event_id',
    name: 'view_event',
    component: ViewEvent,
    meta: { requiresAuth: false }
  },

  {
    path: '/view_incidents',
    name: 'view_incidents',
    component: ViewIncidents,
    meta: { requiresAuth: false }
  },

  {
    path: '/create_membership',
    name: 'create_membership',
    component: CreateMembership,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_form/',
    name: 'create_form',
    component: CreateForm,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_form/:profile_tab_id',
    name: 'create_form_tab',
    component: CreateForm,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_section/:form_id/',
    name: 'create_section',
    component: CreateSectionQuestion,
    meta: { requiresAuth: true }
  },
  {
    path: '/manage_sections',
    name: 'manage_section',
    component: ManageSections,
    meta: { requiresAuth: true }
  },
  {
    path: '/assign_sections/:form_id/',
    name: 'assign_sections',
    component: ManageSections,
    meta: { requiresAuth: true }
  },
  {
    path: '/community_asset',
    name: 'community_asset',
    component: CommunityAsset,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_service',
    name: 'create_service',
    component: CreateService,
    meta: { requiresAuth: true }
  },


  {
    path: '/view_membership/',
    name: 'view_membership',
    component: ViewMembership,
    meta: { requiresAuth: true }
  },

  {
    path: '/assign_questions/:section_id',
    name: 'assign_questions',
    component: AssignQuestion,
    meta: { requiresAuth: true }
  },

  {
    path: '/manage_questions/',
    name: 'view_questions',
    component: ManageQuestion,
    meta: { requiresAuth: true }
  },
  {
    path: '/folder/:portal_id/:id',
    name: 'Folder',
    component: FolderView,
    props: true,
  },
  {
    path: '/view_business_profiles',
    name: 'view_business_profiles',
    component: ViewBusinessProfiles,
    meta: { requiresAuth: false }
  },
  {
    path: '/view_personal_profiles',
    name: 'view_personal_profiles',
    component: ViewProfileProfiles,
    meta: { requiresAuth: false }
  },
  {
    path: '/view_all_groups',
    name: 'view_all_groups',
    component: ViewAllGroups,
    meta: { requiresAuth: true }
  },
  {
    path: '/publish_portal/:portal_id/:portal_name',
    name: 'publish_portal',
    component: PublishPortal,
    meta: { requiresAuth: false }
  },
  {
    path: '/events',
    name: 'events',
    component: AllEvents,
    meta: { requiresAuth: false }
  },
  {
    path: '/upcoming_birthdays',
    name: 'upcoming_birthdays',
    component: UpcomingBirthdays,
    meta: { requiresAuth: false }
  },
  {
    path: '/personal_profile_list',
    name: 'personal_profile_list',
    component: PersonalProfileList,
    meta: { requiresAuth: false }
  },
  {
    path: '/adverts',
    name: 'adverts',
    component: Adverts,
    meta: { requiresAuth: false }
  },
  {
    path: '/view_full_report/:report_id/:portal_id/:portal_name',
    name: 'view_full_report',
    component: ViewPublishReport,
    meta: { requiresAuth: false }
  },

  {
    path: "/checkout/:order_id",
    name: "checkout",
    component: CheckoutPage,
    props: true,
    meta: { requiresAuth: true }
  },

  {
    path: "/cart_checkout/:checkout_slug?",
    name: "cart_checkout",
    component: CartCheckoutView,
    props: true,
    meta: { requiresAuth: true }
  },

  {
    path: '/view_membership_users/:membership_id',
    name: 'view_membership_users',
    component: ViewMembershipUsers,
    meta: { requiresAuth: true }
  },
  {
    path: '/view_board/:portal_id/:board_id/:board_name',
    name: 'view_board',
    component: Board,
  },
  {
    path: '/view_business_dashboard',
    name: 'view_business_dashboard',
    component: BusinessDashboard,
    meta: { requiresAuth: true }
  },

  {
    path: '/view_all_birthdays',
    name: 'view_all_birthdays',
    component: ViewAllBirthdays
  },

  {
    path: '/view_event_tickets_dashboard/:event_id',
    name: 'ticket_dashboard',
    component: ViewUserTickets,
    meta: { requiresAuth: true }
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQ,
    meta: { requiresAuth: true }
  },
  {
    path: '/library',
    name: 'library',
    component: library,
  },
  {
    path: '/view_recent_uploads',
    name: 'view_recent_uploads',
    component: ViewRecentUploads,
    meta: { requiresAuth: true }
  },
  {
    path: '/create_profile_tabs',
    name: 'create_profile_tabs',
    component: CreateProfileTabs,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'landing',
    component: NSPLanding,
  },
  {
    path: '/knowledgehub',
    name: 'knowledgehub',
    component: KnowledgeHub,
  },
  {
    path: '/assessment_tools',
    name: 'assessment_tools',
    component: AssessmentTools,
  },
  {
    path: '/courses',
    name: 'courses',
    component: Courses,
  },
  {
    path: '/create_assets',
    name: 'create_assets',
    component: CreateAssets,
    meta: { requiresAuth: true }
  },
  {
    path: '/youth_empowerment',
    name: 'youth_empowerment',
    component: NationalYouthPolicyDashboard,
  },
  {
    path: '/pwd',
    name: 'pwd',
    component: PWD,
  },
  {
    path: '/gbv',
    name: 'gbv',
    component: GBV,
  },
  {
    path: '/insights',
    name: 'insights',
    component: KnowledgeInsights,
  },

  {
    path: '/create_discussion',
    name: 'create_discussion',
    component: CreateDiscussion,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_survey',
    name: 'create_survey',
    component: CreateSurvey,
    meta: { requiresAuth: true }
  },

  {
    path: '/create_polls',
    name: 'create_polls',
    component: CreatePolls,
    meta: { requiresAuth: true }
  },

  {
    path: '/search',
    name: 'unified_search',
    component: UnifiedSearchResults,
    meta: { requiresAuth: true }
  },

  {
    path: '/orders',
    name: 'orders',
    component: OrderView,
    meta: { requiresAuth: true }
  },
  {
    path: '/credit_management',
    name: 'credit_management',
    component: CreditManagementView,
    meta: { requiresAuth: true }
  },
  {
    path: '/my_orders',
    name: 'my_orders',
    component: MyOrdersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/my_shop',
    name: 'my_shop',
    component: MyShopView,
    meta: { requiresAuth: true }
  },
  {
    path: '/manage_promotions',
    name: 'manage_promotions',
    component: PromoCodesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/manage_catalogue',
    name: 'manage_catalogue',
    component: ManageCatalogue,
    meta: { requiresAuth: true }
  },
  {
    path: '/donation_campaigns',
    name: 'donation_campaigns',
    component: DonationCampaignsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/my_donation_campaigns',
    name: 'my_donation_campaigns',
    component: MyDonationCampaignsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/donation_campaigns_dashboard',
    name: 'donation_campaigns_dashboard',
    component: DonationCampaignDashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/product/:slug',
    name: 'ProductView',
    component: ProductView,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'page_not_found',
    component: PageNotFound,
    meta: { requiresAuth: false }
  },
  {
    path: '/manage_event/:event_id',
    name: 'manage_event',
    component: ManageEvent,
    meta: { requiresAuth: true }
  },
  {
    path: '/dsd_dashboard',
    name: 'dsd_dashboard',
    component: DSD,
    meta: { requiresAuth: true }
  },
   {
    path: '/manage_membership/:user_id',
    name: 'manage_membership',
    component: manage_membership,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

function is_internal() {
  return process.env.VUE_APP_IS_INTERNAL === 'true';
}

function get_aic_one_login_url() {
  return process.env.VUE_APP_AIC_ONE_LOGIN_URL || null;
}

function get_client_domain() {
  const client_domain = document.documentElement.getAttribute('data-client');
  return client_domain.toLowerCase();
}


router.beforeEach((to, from, next) => {
  const invite_routes = ['organization_invite', 'organization_invite_setup'];
  const is_invite_route = invite_routes.includes(to.name);

  if (to.query.token && !is_invite_route) {
    const sso_token = to.query.token;
    localStorage.setItem('encrypted_token', sso_token);
    localStorage.setItem('token', sso_token);

    const clean_query = { ...to.query };
    delete clean_query.token;

    return next({
      path: to.path,
      query: clean_query,
      replace: true
    });
  }
  const token = localStorage.getItem('encrypted_token') || localStorage.getItem('token') || to.params.token;

  if (is_internal() && !token) {
    const url = get_aic_one_login_url();
    if (url) {
      window.location.replace(`${url}?next=engagenet`);
      return;
    }
  }
  const domain = get_client_domain();

  // ✅ Restrict who can see the landing page
  if (to.path === '/') {
    // Only special domains should access '/'
    if (
      domain.includes('soulcity') ||
      domain.includes('nsp')
    ) {
      // Allowed
      return next();
    } else if (domain.includes('dwypd')) {
      return next('/knowledgehub');
    } else if (domain.includes('vettedsa')) {
      return next('/marketplace');
    } else {
      // Redirect all other domains to sign-in
      return next('/sign_in_finale');
    }
  }
  // ✅ Handle sign-in page logic
  if (to.path === '/sign_in_finale') {
    if (token) {
      // Already logged in → send to home
      return next('/home');
    } else if (
      domain.includes('soulcity') ||
      domain.includes('nsp')
    ) {
      // For special domains → go to landing
      return next('/');
    } else {
      // Otherwise, stay on sign-in
      return next();
    }
  }
  // ✅ Protect routes that require authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      return next('/sign_in_finale');
    }
  }

  if (to.matched.some(record => record.meta.requires_organization_admin)) {
    if (!organizationProfile.is_organization_admin_role(get_user_details())) {
      return next('/home');
    }
  }

  next();
})

router.afterEach((to) => {
  seo.applyRouteSeo(to);
});



export function clear_token() {
  localStorage.removeItem('encrypted_token');
  localStorage.removeItem('user_role');
  localStorage.removeItem('first_name');
  localStorage.removeItem('last_name');
  localStorage.removeItem('user_id');
  localStorage.removeItem('phone_number');
  localStorage.removeItem('email');
  localStorage.removeItem('aic_one_login');
  localStorage.removeItem('organization_id');
  localStorage.removeItem('active_organization_id');
  localStorage.removeItem('active_business_profile_company_id');
  localStorage.removeItem('organization_name');
  localStorage.removeItem('company_name');
  localStorage.removeItem('type_of_organization');
  localStorage.removeItem('organization_description');
  localStorage.removeItem('organization_email');
  localStorage.removeItem('organization_tell_number');
  localStorage.removeItem('organization_location');
  localStorage.removeItem('organization_logo');
  localStorage.removeItem('organization_cover');
  localStorage.removeItem('active_profile');
  localStorage.removeItem('activeProfile');
  localStorage.removeItem('base_profile');
  localStorage.removeItem('activeBaseProfile');
  localStorage.removeItem('active_profile_type');
  localStorage.removeItem('active_organization_logo');

  Object.keys(localStorage)
    .filter((key) => key.startsWith('organization_branding_'))
    .forEach((key) => {
      localStorage.removeItem(key);
    });

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('auth:cleared'));
  }
}
export function set_user_details(user_details) {
  // 1. Extract values, including aic_one_login, from the object
  // We use destructuring to create the variable names directly
  const {
    role,
    first_name = '',
    last_name = '',
    id: user_id = '',
    first_time_login = false,
    phone_number = '',
    email = '',
    organization_name = '',
    company_name = '',
    type_of_organization = '',
    organization_description = '',
    organization_email = '',
    organization_tell_number = '',
    organization_location = '',
    organization_id = '',
    logo = '',
    cover = '',
    aic_one_login = false // This captures the value from your AICone payload
  } = user_details;
  // 2. Handle the nested role object safely
  const user_role = role && role.role ? role.role : '';

  // 3. Save standard details to localStorage
  localStorage.setItem('user_role', user_role);
  localStorage.setItem('first_name', first_name);
  localStorage.setItem('last_name', last_name);
  localStorage.setItem('user_id', user_id);
  localStorage.setItem('first_time_login', first_time_login);
  localStorage.setItem('phone_number', phone_number);
  localStorage.setItem('email', email);
  localStorage.setItem('organization_name', organization_name || company_name || '');
  localStorage.setItem('company_name', company_name || organization_name || '');
  localStorage.setItem('type_of_organization', type_of_organization || '');
  localStorage.setItem('organization_description', organization_description || '');
  localStorage.setItem('organization_email', organization_email || '');
  localStorage.setItem('organization_tell_number', organization_tell_number || '');
  localStorage.setItem('organization_location', organization_location || '');
  if (organization_id) {
    localStorage.setItem('organization_id', organization_id);
  }
  localStorage.setItem('organization_logo', logo || '');
  localStorage.setItem('organization_cover', cover || '');
  if (organization_id) {
    localStorage.setItem('active_profile_type', 'business');
  } else {
    localStorage.removeItem('active_profile_type');
  }

  localStorage.setItem('aic_one_login', aic_one_login.toString());
}

export function get_user_details() {
  // Retrieve everything and convert the string 'true'/'false' back to a Boolean
  return ({
    "user_role": localStorage.getItem('user_role'),
    "first_name": localStorage.getItem('first_name'),
    "last_name": localStorage.getItem('last_name'),
    "user_id": localStorage.getItem('user_id'),
    "phone_number": localStorage.getItem('phone_number'),
    "email": localStorage.getItem('email'),
    "organization_name": localStorage.getItem('organization_name'),
    "company_name": localStorage.getItem('company_name'),
    "type_of_organization": localStorage.getItem('type_of_organization'),
    "organization_description": localStorage.getItem('organization_description'),
    "organization_email": localStorage.getItem('organization_email'),
    "organization_tell_number": localStorage.getItem('organization_tell_number'),
    "organization_location": localStorage.getItem('organization_location'),
    "organization_id": localStorage.getItem('organization_id'),
    "organization_logo": localStorage.getItem('organization_logo'),
    "organization_cover": localStorage.getItem('organization_cover'),
    "first_time_login": localStorage.getItem('first_time_login'),
    "aic_one_login": localStorage.getItem('aic_one_login') === 'true'
  });
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

export function is_valid_csrf_token(token) {
  return typeof token === 'string' && /^[A-Za-z0-9]{32,64}$/.test(token);
}

export function csrf_headers(token) {
  const candidateToken = token ?? getCookie('csrftoken');
  if (is_valid_csrf_token(candidateToken)) {
    return { 'X-CSRFToken': candidateToken };
  }

  const cookie_token = getCookie('csrftoken');
  if (is_valid_csrf_token(cookie_token)) {
    return { 'X-CSRFToken': cookie_token };
  }

  const stored_token = localStorage.getItem('playground_csrf_token');
  return is_valid_csrf_token(stored_token) ? { 'X-CSRFToken': stored_token } : {};
}

export default router
